/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import weatherStationFieldsetTemplate from './weather-station-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.weatherStation', [])
    .directive('agWeatherStation', WeatherStation)
    .name;

/*@ngInject*/
function WeatherStation() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            weatherStation: '=',
            theForm: '='
        },
        controller: WeatherStationController,
        controllerAs: 'vm',
        templateUrl: weatherStationFieldsetTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function WeatherStationController() {

    let vm = this; //eslint-disable-line

}
